export default "__VITE_ASSET__Dls$vhQm__"